module.exports = __webpack_public_path__ + "static/media/Maf_RecomendacionesTransportistas_not.86b3d4fe.jpg";